import { CommentContainer, selectUser } from '@centerpiece/components';
import { Container } from '@mui/material';
import { useProjectContext } from 'contexts/project.context';
import { useSelector } from 'react-redux';
import {
  useGetCommentsQuery,
  useCreateCommentMutation,
  usePatchCommentMutation,
  useGetProjectContactsQuery,
} from 'store/api';
import { ProjectContact, Comment } from 'store/api/models';
import { CommentsTab } from './CommentsTab';

export const ProjectCommentsTab = ({
  id,
  afterSave,
  exampleProject,
}: {
  id: number;
  afterSave?: Function;
  exampleProject?: any;
}) => {
  const { comments, commentsLoading, project_contacts } = useProjectContext();

  const [createComment] = useCreateCommentMutation();
  const [patchComment] = usePatchCommentMutation();
  return (
    <Container
      maxWidth={'xl'}
      sx={{
        height: '95%',
        overflowY: 'scroll',
        borderRadius: '4px',
        border: theme => `1px solid ${theme.palette.divider}`,
        backgroundColor: `rgba(0, 0, 0, 0.05)`,
        my: 'auto',
        py: 2,
      }}
    >
      <CommentsTab
        comments={comments}
        commentsLoading={commentsLoading}
        recipients={project_contacts}
        afterSave={afterSave}
        foreignKey={{ project: id }}
      />
      {/* <CommentContainer
        comments={comments}
        type={'project'}
        recipients={project_contacts?.map((contact: ProjectContact) => ({
          ...contact?.contact_r,
          name: `${contact?.contact_r?.firstname} ${contact?.contact_r?.lastname}`,
        }))}
        markRead={async () => {
          await patchComment({
            id: 0,
            project: id,
          } as Comment);
          refetchComments();
          afterSave && afterSave();
        }}
        commentsLoading={commentsLoading}
        createComment={async (values: any) => {
          await createComment({
            project: id,
            comment: values.comment,
          });
        }}
      /> */}
    </Container>
  );
};
